// extracted by mini-css-extract-plugin
module.exports = {"big":"GroupCard_big__2v8F3","kindaBig":"GroupCard_kindaBig__gKu0L","centre":"GroupCard_centre__d6knt","link":"GroupCard_link__1IciG"};